
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/help-center/index.vue"
}
